export default __webpack_public_path__ + "static/media/mining.09f40f6e.png";